import { CountUp } from "countup.js";

export class Counter {
  constructor(blockEl) {
    // The container element for this instance (e.g., .block-counter)
    this.blockEl = blockEl;

    // All .number elements inside this particular block
    this.counters = this.blockEl.querySelectorAll(".number");

    // If no counters found, no initialization needed
    if (this.counters.length === 0) return;

    // IntersectionObserver options (can be overridden or extended if needed)
    this.observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5
    };

    this.init();
  }

  init() {
    // Create a single IntersectionObserver for all counters in this block
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      this.observerOptions
    );

    // Observe each counter
    this.setupCounters();
  }

  setupCounters() {
    this.counters.forEach((counterEl) => {
      this.observer.observe(counterEl);
    });
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Start the CountUp animation once in view
        this.initializeCounter(entry.target);

        // Stop observing once triggered (so it doesn’t repeat)
        this.observer.unobserve(entry.target);
      }
    });
  }

  initializeCounter(element) {
    const number = parseFloat(element.getAttribute("data-to")) || 0;
    const decimals = parseInt(element.getAttribute("data-decimals") || 0, 10);
    const duration = parseFloat(element.getAttribute("data-speed")) || 2;

    const counter = new CountUp(element, number, {
      startVal: 0,
      decimalPlaces: decimals,
      duration: duration,
      // Optionally enable these if you want built-in scroll handling from countUp.js:
      enableScrollSpy: true,
      scrollSpyOnce: true,
      // Tweak thresholds if needed for better easing:
      smartEasingThreshold: 10000
    });

    if (!counter.error) {
      counter.start();
    } else {
      console.error(counter.error);
    }
  }
}
